import React from 'react';
import Select from 'react-select';
import { IOpcao } from '@/shared/types/selectOption';
import { ReadLotacaoDto } from '@/api.types';
import { UseFormGetValues } from 'react-hook-form';

interface Props {
  getValues: UseFormGetValues<ReadLotacaoDto>;
  defensorias: IOpcao[];
  nucleos: IOpcao[];
  predios: IOpcao[];
  setoresDisponiveis: IOpcao[];
  refSelectDefensoria: React.Ref<any>;
  refSelectNucleo: React.Ref<any>;
  refSelectPredio: React.Ref<any>;
  refSelectSetor: React.Ref<any>;
  handleSelectChange: (
    selectedOption: IOpcao | null,
    options: IOpcao[],
    field: 'defensoria' | 'nucleo' | 'predio' | 'setor',
  ) => void;
}

export const VinculoLocalCard: React.FC<Props> = ({
  defensorias,
  getValues,
  handleSelectChange,
  nucleos,
  predios,
  refSelectDefensoria,
  refSelectNucleo,
  refSelectPredio,
  refSelectSetor,
  setoresDisponiveis,
}) => {
  return (
    <>
      <div className="card mb-3">
        <div className="card-header text-center">Defensoria/Núcleo</div>
        <div className="card-body row">
          <div className="mb-3">
            <label className="form-check-label" htmlFor="inlineRadio1">
              Defensoria
            </label>
            <Select id="defensoria"
              ref={refSelectDefensoria}
              isClearable
              defaultValue={defensorias.find(
                (a) => a.value === getValues()?.defensoria?.id,
              )}
              options={defensorias}
              placeholder=""
              onChange={(e) => {
                handleSelectChange(e, defensorias, 'defensoria');
              }}
            />
          </div>
          <div>
            <label className="form-check-label" htmlFor="inlineRadio2">
              Núcleo
            </label>
            <Select id="nucleo"
              ref={refSelectNucleo}
              isClearable
              defaultValue={nucleos.find(
                (a) => a.value === getValues()?.nucleo?.id,
              )}
              options={nucleos}
              placeholder=""
              onChange={(e) => handleSelectChange(e, nucleos, 'nucleo')}
            />
          </div>
        </div>
      </div>

      <div className="card mb-3">
        <div className="card-header text-center">Setores</div>
        <div className="card-body row">
          <div className="mb-3">
            <label htmlFor="predio" className="form-label">Prédio:</label>
            <Select
              id="predio"
              ref={refSelectPredio}
              isClearable
              defaultValue={predios.find(
                (a) => a.value === getValues()?.setor?.predio?.id,
              )}
              options={predios}
              placeholder="Selecione o prédio"
              onChange={(e) => handleSelectChange(e, predios, 'predio')}
            />
          </div>
          <div>
            <label htmlFor="setor" className="form-label">Setor:</label>
            <Select
              id="setor"
              ref={refSelectSetor}
              isClearable
              value={setoresDisponiveis.find(
                (a) => a.value === getValues()?.setor?.id,
              )}
              options={setoresDisponiveis}
              placeholder="Selecione o setor"
              onChange={(e) => handleSelectChange(e, setoresDisponiveis, 'setor')}
            />
          </div>
        </div>
      </div>
    </>
  );
};
